module.exports = __webpack_public_path__ + "img/plus-button.f65d1dc3.svg";